export default __webpack_public_path__ + "static/media/condoImgDefault.240d8350.svg";